import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappCloudApiContent from './WhatsappCloudApiContent';

const WhatsappCloudApi = () => (
  <>
    <Helmet>
      <title>WhatsApp Cloud API Integration for Business | HAWKTRION</title>
      <meta name="description" content="Integrate WhatsApp Cloud API with your business apps using HAWKTRION. Connect messaging, templates, webhooks, CRM workflows, and customer updates." />
      <meta name="keywords" content="WhatsApp Cloud API, WhatsApp Cloud API integration, WhatsApp Business Platform API" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-cloud-api/" />
      <meta property="og:title" content="WhatsApp Cloud API Integration for Business | HAWKTRION" />
      <meta property="og:description" content="Integrate WhatsApp Cloud API with your business apps using HAWKTRION. Connect messaging, templates, webhooks, CRM workflows, and customer updates." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-cloud-api/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp Cloud API Integration for Business | HAWKTRION" />
      <meta name="twitter:description" content="Integrate WhatsApp Cloud API with your business apps using HAWKTRION. Connect messaging, templates, webhooks, CRM workflows, and customer updates." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp Cloud API for Business Messaging and Automation" hideCta>
      <WhatsappCloudApiContent />
    </SeoLandingPage>
  </>
);

export default WhatsappCloudApi;